module.exports = __webpack_public_path__ + "img/pin01.69667cdc.png";